import { ReactElement } from "react";
import { Box } from "@mui/material";

type Props = {
  hasScroll?: boolean;
  children: ReactElement | ReactElement[];
};

export function ContentWrapper({ children, hasScroll }: Props) {
  return (
    <Box
      id="content-wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - (72px + 56px))",
        overflowY: hasScroll ? "auto" : "hidden",
      }}
    >
      {children}
    </Box>
  );
}
